<template>
  <div>
    <div class="error-container pl-3">
      <div class="d-flex">
        <span class="color-primary-4 font-16 font-weight-bold flex-grow-1">
          {{ title }}
        </span>
        <div
          class="d-flex align-items-center px-2 rounded-pill border-color--primary-4 cursor-pointer"
          @click="$emit('close')"
        >
          <em class="fa fa-times-circle mr-2 color-primary-4" />
          <span class="color-primary-4 font-16">Cerrar</span>
        </div>
      </div>
      <div v-if="errors.length > 0">
        <ul class="m-0 pl-4 error-description">
          <li
            v-for="(item, index) in errors"
            :key="`error-container-${index}`"
            class="color-primary-4"
          >
            <span class="font-16"><div v-html="item"></div></span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomError',
  props: {
    title: {
      type: String,
      default: () => 'Error',
    },
    descriptionHeight: {
      type: String,
      default: () => '55px',
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables/_colors.scss';

.error-container {
  border-radius: 5px 5px 0px 5px;
  padding: 10px;
  background: map-get($colors, 'pink-1');
}
.error-description {
  overflow-wrap: break-word;
  margin-right: 5% !important;
  height: v-bind(descriptionHeight);
  overflow-y: auto;
}
::-webkit-scrollbar {
  width: 14px;
}

/* Buttons */
::-webkit-scrollbar-button:single-button {
  background-color: map-get($colors, 'pink-1');
  display: block;
  border-style: solid;
  height: 13px;
  width: 16px;
}
/* Up */
::-webkit-scrollbar-button:single-button:vertical:decrement {
  border-width: 0 7px 7px 7px;
  border-color: transparent transparent #c5525c transparent;
}

::-webkit-scrollbar-button:single-button:vertical:decrement:hover {
  border-color: transparent transparent #c5525c transparent;
}
/* Down */
::-webkit-scrollbar-button:single-button:vertical:increment {
  border-width: 7px 7px 0 7px;
  border-color: #c5525c transparent transparent transparent;
}
</style>
